export const Options = {
    Salutation: [
        { text: "-", value:"keine Angabe"},
        { text: "Divers", value: "D" },
        { text: "Frau", value: "W" },
        { text: "Herr", value: "M" },
    ],
    Sex: [
        { text: "-", value:"keine Angabe"},
        { text: "Divers", value: "D" },
        { text: "Mrs", value: "W" },
        { text: "Mr", value: "M" },
    ],
    AdditionalConsent: [
        "Ich bin damit einverstanden, dass meine Daten auch über eine konkrete  Stellenbesetzung hinaus gespeichert werden und ich auf interessante Stellenangebote und News hingewiesen werden.",
        "Ich möchte, dass meine Daten nach dem aktuellen Bewerbungsverfahren gelöscht werden.",
    ],
    AdditionalConsentEnglisch: [
        "I consent to the storage of my data beyond the scope of the specific application process, and to being contacted with information about interesting job openings and news.",
        "Please delete my data once the current application procedure has ended.",
    ],
     BecomingAwareThroughYoungsters: [
        { text: "-",value:"keine Angabe"},
        { text: "Talent Rocket",value:"Talent Rocket"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "Beck",value:"Beck"},
        { text: "LTO",value:"LTO"},
        { text: "Azur",value:"Azur"},
        { text: "Familie/ Freunde",value:"Familie/ Freunde"},
        { text: "Juracon Frankfurt",value:"Juracon Frankfurt"},
        { text: "Juracon München",value:"Juracon München"},
        { text: "Fakultätskarrieretag Heidelberg",value:"Fakultätskarrieretag Heidelberg"},
        { text: "Fakultätskarrieretag Berlin",value:"Fakultätskarrieretag Berlin"},
        { text: "Juristenmesse der LMU",value:"Juristenmesse der LMU"},
        { text: "Young Talents Newsletter",value:"Young Talents Newsletter"},
        { text: "Lawgentur",value:"Lawgentur"},
        { text: "Personalvermittler",value:"Personalvermittler"}
    ],
     BecomingAwareThroughLawyers: [
        { text: "keine Angabe",value:"keine Angabe"},
        { text: "Talent Rocket",value:"Talent Rocket"},
        { text: "Beck",value:"Beck"},
        { text: "LTO",value:"LTO"},
        { text: "Azur",value:"Azur"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "Familie/ Freunde",value:"Familie/ Freunde"},
        { text: "Messen/ Events",value:"Messen/ Events"},
        { text: "Stepstone",value:"Stepstone"},
        { text: "Indeed",value:"Indeed"},
        { text: "Lawgentur",value:"Lawgentur"},
        { text: "Personalvermittler",value:"Personalvermittler"}
    ],
    BecomingAwareThroughEnglish: [
       { text: "-",value:"keine Angabe"},
       { text: "LinkedIn",value:"LinkedIn"},
       { text: "GSK Homepage",value:"GSK Homepage"},
       { text: "Jobs.lu",value:"Jobs.lu"},
       { text: "Lawgentur",value:"Lawgentur"}
   ]
}
